import { matchPath } from "react-router-dom";

export function isRouteActive(item, pathname) {
  return Boolean(
    item.route && item.route !== "#" && matchPath({ path: item.route, end: true }, pathname)
  );
}
export function isBranchActive(item, pathname) {
  return (
    isRouteActive(item, pathname) ||
    Boolean(item.collapse?.some((child) => isBranchActive(child, pathname)))
  );
}
// Los grupos organizan las vistas; cada hoja mantiene su permiso actual.
export function filterNavigation(routes, hasPermission) {
  return routes.flatMap((item) => {
    if (item.public) return [];
    if (item.type === "title" || item.type === "divider") return [item];
    if (item.collapse) {
      const collapse = filterNavigation(item.collapse, hasPermission);
      return collapse.length ? [{ ...item, collapse }] : [];
    }
    return !item.permissionKey || hasPermission(item.permissionKey) ? [item] : [];
  });
}
